import "./App.css";
import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import Navigator from "./Navigator";
import ApiClientProvider from "./apiService/Client";
import { ConfigProvider } from "antd";
import { antDTheme } from "./theme";
import { StyleProvider } from "@ant-design/cssinjs";
import Modal from "@Components/Modal/Modal";
import useAuthStore from "./stores/authStore";
import { initBugReporter, setReporterUser } from "./services/bugReporter";


const App = () => {
  const userData = useAuthStore((s) => s.userData);

  // Register the InstantTasks bug reporter once, client-side (DOM-only widget).
  useEffect(() => {
    initBugReporter();
  }, []);

  // Attribute reports to the logged-in admin; clear on logout.
  useEffect(() => {
    setReporterUser(
      userData?.email
        ? {
            email: userData.email,
            fullName:
              [userData.firstName, userData.lastName]
                .filter(Boolean)
                .join(" ")
                .trim() || undefined,
          }
        : null,
    );
  }, [userData]);

  return (
    <StyleProvider layer>
      <ConfigProvider theme={antDTheme}>
        <ApiClientProvider>
          <BrowserRouter>
            <Navigator />
            <Modal />
          </BrowserRouter>
        </ApiClientProvider>
      </ConfigProvider>
    </StyleProvider>
  );
};

export default App;
